<script>
import ProjectActionCategoryService from "@/services/ProjectActionCategoryService";
import ProjectActionService from "@/services/ProjectActionService";
import UserService from "@/services/UserService";
import Cloner from "@/libraries/Cloner";
import { mapGetters } from "vuex";
import ActionViewer from "./components/ActionViewer.vue";

export default {
    props: {
        context: {},
        projectId: {},
        linkToStatus: {},
        projectMomId: {}
    },
    components: { ActionViewer },
    data() {
        return {
            editing: false,
            loading: true,
            categories: [],
            users: [],
            saving: false,
            errors: false,
            preview: null,
            pLoading: false,
            linkables: [],
            entity: {
                id: null,
                action_category_id: null,
                project_id: null,
                project_mom_id: null,
                linked_action_id: null,
                user_id: null,
                due_date: null,
                notes: null,
                status: 0,
                action_type: "2"
            }
        };
    },
    computed: {
        ...mapGetters("auth", ["getMyId"]),
        actionTypes() {
            return {
                1: this.$t("project_actions.atype_status"),
                2: this.$t("project_actions.atype_task")
            };
        },
        linkedAction() {
            return this.entity.linked_action_id;
        }
    },
    watch: {
        linkedAction: async function(nV, oV) {
            this.pLoading = true;
            if (parseInt(nV) > 0) {
                try {
                    const { data } = await ProjectActionService.GETS(nV);
                    this.preview = data.data;
                } catch (e) {
                    console.log("watch linkedfACtion e", e);
                }
            } else {
                this.preview = null;
            }
            this.pLoading = false;
        }
    },
    async created() {
        if (!this.context.empty) {
            this.editing = true;
            this.entity = Cloner.pickClone(this.context, [
                "id",
                "project_id",
                "user_id",
                "linked_action_id",
                "due_date",
                "notes",
                "status",
                "action_type"
            ]);
        } else {
            this.entity.project_id = this.projectId;
            this.entity.user_id = this.getMyId;
            if (this.projectMomId) {
                this.entity.project_mom_id = this.projectMomId;
            }
        }
        await this.getLinkable();

        // Link status during creation
        if (this.linkToStatus !== null) {
            this.entity.linked_action_id = this.linkToStatus;
        }

        await this.fetchCategories();
        await this.fetchUsers();
        this.loading = false;
    },
    methods: {
        async getLinkable() {
            try {
                const params = {
                    linked_action_id: this.entity.linked_action_id
                };
                if (this.projectMomId) {
                    params.project_mom_id = this.projectMomId;
                } else {
                    params.context = "datatab";
                }
                const { data } = await ProjectActionService.GET_linkable(
                    this.projectId,
                    1,
                    params
                );
                this.linkables = data.data;
            } catch (e) {
                console.log("getLinkable e", e);
            }
        },
        async saveForm() {
            try {
                if (this.editing) {
                    await ProjectActionService.PUT(this.entity);
                } else {
                    await ProjectActionService.POST(this.entity);
                }
                this.$emit("close-reload");
            } catch (e) {
                this.errors = e.response.data.errors;
            }
        },
        async fetchCategories() {
            try {
                const params = {};
                if (this.projectMomId) {
                    params.project_mom_id = this.projectMomId;
                } else {
                    params.context = "datatab";
                }
                const {
                    data
                } = await ProjectActionCategoryService.GET_dropdown(
                    this.projectId,
                    params
                );
                this.categories = data.data;
            } catch (e) {
                console.log("fc e", e);
            }
        },
        /**
         * Fetch users
         */
        async fetchUsers() {
            try {
                const r = await UserService.dropdown();
                this.users = r.data.data;
            } catch (e) {}
        },
        async deleteEntity() {
            this.$swal({
                icon: "warning",
                text: this.$t("project_actions.delete_are_you_sure"),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    try {
                        this.$notify({
                            message: this.$t("project_actions.notify_deleted"),
                            timeout: 5000,
                            icon: "far fa-check",
                            type: "success"
                        });
                        await ProjectActionService.DELETE(this.entity.id);

                        this.$emit("close-reload");
                    } catch (e) {}
                }
            });
        }
    }
};
</script>

<template>
    <modal
        size="xl"
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            <template v-if="editing"
                >{{ $t("project_actions.edit_task") }}
            </template>
            <template v-else>{{ $t("project_actions.create_task") }}</template>
        </template>

        <template slot="default">
            <FormulateForm :errors="errors" @submit="saveForm" v-model="entity">
                <div class="row">
                    <FormulateErrors />

                    <div class="col-12" v-if="false">
                        <FormulateInput
                            type="select"
                            :options="actionTypes"
                            :label="$t('project_actions.entry_type')"
                            :placeholder="$t('project_actions.entry_type')"
                            name="action_type"
                        />
                    </div>
                    <div class="col-12">
                        <FormulateInput
                            type="multiselect"
                            :options="users"
                            :label="$t('project_actions.owner')"
                            :placeholder="$t('project_actions.owner')"
                            name="user_id"
                        />
                    </div>

                    <div class="col-12">
                        <FormulateInput
                            type="date"
                            name="due_date"
                            :label="$t('project_actions.hdr_due')"
                        />
                    </div>
                    <div class="col-12">
                        <FormulateInput
                            type="fswitch"
                            name="status"
                            :label="$t('project_actions.hdr_is_completed')"
                        />
                    </div>

                    <div class="col-12">
                        <FormulateInput
                            name="notes"
                            type="textarea"
                            :placeholder="$t('project_actions.hdr_description')"
                            :label="$t('project_actions.hdr_description')"
                            rows="8"
                            validation="required"
                        />
                        <FormulateInput
                            name="linked_action_id"
                            type="multiselect"
                            :options="linkables"
                            :label="$t('project_actions.link_task_to_a_status')"
                        />
                        <div>
                            <v-loader :loading="pLoading" v-if="pLoading" />
                            <template v-else>
                                <action-viewer :action="preview" />
                            </template>
                        </div>

                        <div class="row mt-4">
                            <div class="col">
                                <base-button
                                    type="danger"
                                    :outline="true"
                                    @click="deleteEntity"
                                    v-if="editing"
                                    ><i class="far fa-trash"></i>
                                    {{ $t("delete") }}</base-button
                                >
                            </div>
                            <div class="col text-right">
                                <base-button
                                    type="secondary"
                                    :outline="true"
                                    @click="$emit('close')"
                                    >{{ $t("cancel") }}</base-button
                                >
                                <base-button
                                    type="primary"
                                    :loading="saving"
                                    native-type="submit"
                                    >{{ $t("save") }}</base-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
